import { type InjectionKey, type Ref } from 'vue';

export type QrGenerationStatus = 'idle' | 'verifying' | 'success' | 'error';

export const qrGenerationStatusKey: InjectionKey<Ref<QrGenerationStatus>> =
  Symbol('qrGenerationStatus');
